import type { DefaultNamespace } from 'i18next'

interface InputHelpTextProps {
	error?: string | DefaultNamespace
	helpText?: string | DefaultNamespace
}
export const InputHelpText = ({ error, helpText }: InputHelpTextProps) => {
	return (
		<>
			{error && (
				<small className='text-danger-500 text-sm'>{error}</small>
			)}
			{helpText && !error && (
				<small className='text-neutral-500 text-sm'>{helpText}</small>
			)}
		</>
	)
}

InputHelpText.displayName = 'InputHelpText'
